<template>
    <div>
        <div class="mb-3 d-flex">
            <v-divider class="border-opacity-100" vertical :thickness="4" :color="$system.systemSettings.knowledge_base_color"></v-divider>
            <h2 class="mb-1 ms-2">{{ article.name }}</h2>
        </div>
        <div class="mb-1 d-flex align-center justify-space-between">
            <p class="text-small d-inline text-grey-darken-2">تاریخ آخرین بروزرسانی {{ $moment(article.updated_date).format('HH:mm jYYYY/jMM/jDD') }}</p>
            <v-btn v-tooltip="'کپی لینک'" icon="icon-copykb" variant="text" @click="copyLink"></v-btn>
        </div>
        <v-divider class="border-opacity-50"></v-divider>
        <div class="pb-3 mt-5 ck-content" v-html="article.body"></div>
        <v-divider class="border-opacity-50"></v-divider>
        <v-chip-group>
            <v-chip @click="$router.replace({query: {search: item.name}})" class="rounded-lg" v-for="item in article.tags">{{ item.name }}</v-chip>
        </v-chip-group>
        <div class="d-flex align-center justify-center" v-if="!like">
            <p class="text-grey-darken-2 text-meta">آیا این مطلب برای شما مفید بود؟</p>
            <v-btn variant="outlined" icon="icon-like" color="success" @click="satisfaction(true)" class="mx-3"></v-btn>
            <v-btn variant="outlined" icon="icon-dislike" color="error" @click="satisfaction(false)"></v-btn>
        </div>
        <p v-if="article.related_articles.length" class=" font-weight-medium test-start mt-12 text-grey-darken-3 text-meta">شاید مقالات زیر برای شما مفید باشد:</p>
        <div class="d-flex align-center mb-3 pa-4 border cursor-pointer rounded" v-for="item in article.related_articles" @click="$router.push({ path: `/kb/articles/${item.id}/${item.slug}` }); searchDialog = false;">
            <v-icon size="21" class="me-2" color="grey-darken-1">icon-filekb</v-icon>
            <p class="text-meta text-grey-darken-3 flex-grow-1">{{ item.name }}</p>
            <v-divider class="mx-2 border-opacity-50" vertical></v-divider>
            <v-icon v-if="item.read_time" class="me-2" color="grey-darken-1" size="16">icon-timekb</v-icon>
            <p v-if="item.read_time" class="text-small text-grey-darken-2">{{ item.read_time }} دقیقه</p>
        </div>
    </div>
</template>
<script>
export default {
    layout:"kb",
    auth: false,
    validate(context) {
        return context.system.systemSettings.kb_core && context.system.systemSettings.knowledge_base_status;
    },
    data() {
        return {
            article:{
                related_articles:[]
            },
            like: false,
        }
    },
    methods: {
        satisfaction(like){
            this.$kbArticleUpdate(this.$route.params.id, {like: like}).then(res => {
                if(res && res.status == "OK"){
                    this.$toast.success('نظر شما با موفقیت ثبت گردید.')
                    let satisfactionList = localStorage.getItem("satisfactionArticles") ?? {};
                    Object.assign(satisfactionList, {
                        [this.$route.params.id]: like
                    })
                    localStorage.setItem("satisfactionArticles", {...satisfactionList});
                    this.like = true;
                }
            })
        },
        copyLink() {
            this.$text.copy(window.location.href);
        },
        async getArticle() {
            this.$loading.start();
            if (Object.hasOwn(localStorage.getItem("satisfactionArticles") ?? {}, this.$route.params.id))
                this.like = true;
            this.$kbArticleGet(this.$route.params.id).then(res => {
                if(res && res.status == "OK") {
                    this.article = res.data;
                    this.setMetaTitles();
                    setTimeout(() => {
                        window.Prism.highlightAll();
                    }, 1000);
                }
            }).finally(() => this.$loading.finish());
        },
        setMetaTitles() {
          document.title = this.article.name;
          this.$headTag.add('meta[name="$description"]', 'meta', { name: 'description', content: this.article.meta });
          this.$headTag.add('link[id="helpical-canonical"]', 'link', { id: 'helpical-canonical', rel: 'cononical', href: window.location.href.split('/').splice(0, window.location.href.split('/').length - 1).join('/') });
        },
        resetMetaTitles() {
          document.title = this.$system.systemSettings.system_title;
          this.$headTag.remove('meta[name="$description"]');
          this.$headTag.remove('link[id="helpical-canonical"]');
        }
    },
    created() {
        this.getArticle();
    },
    unmounted() {
        this.resetMetaTitles();
    }
}
</script>
